import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import getServiceNameFromUrl, { getServiceIconFromUrl } from '../../lib/getServiceNameFromUrl';

import PillButton from '../buttons/PillButton';
import Date from './Date';
import Sponsor from './Sponsor';

import styles from '../../styles/partials/broadcasts.module.css';

interface BroadcastsProps {
    broadcasts?: Broadcast[] | null;
    type: 'video' | 'podcast' | null;
    className?: string | null;
    buttonClassName?: string | null;
    sponsorClassName?: string | null;
}

function Broadcasts({
    broadcasts = null,
    type = 'video',
    className = null,
    buttonClassName = null,
    sponsorClassName = null,
}: BroadcastsProps) {
    return (
        <div className={classNames([styles.container, className])}>
            {broadcasts
                .filter(({ type }) => type === 'streaming')
                .map(({ id, url }) => {
                    const icon = getServiceIconFromUrl(url);
                    return (
                        <PillButton
                            key={`broadcast-${id}`}
                            href={url}
                            external
                            className={classNames([styles.button, buttonClassName])}
                        >
                            {icon !== null && icon.match(/^fa-/) !== null ? (
                                <i className={classNames(['fa-brands', icon, styles.icon])} />
                            ) : (
                                <span
                                    className={classNames([
                                        'material-symbols-rounded',
                                        styles.icon,
                                    ])}
                                >
                                    {icon || 'open_in_new'}
                                </span>
                            )}
                            <span className={styles.label}>
                                {icon !== null ? (
                                    getServiceNameFromUrl(url)
                                ) : type === 'podcast' ? (
                                    <FormattedMessage
                                        defaultMessage="Écouter sur {broadcast}"
                                        description="Button label"
                                        values={{
                                            broadcast: getServiceNameFromUrl(url),
                                        }}
                                    />
                                ) : (
                                    <FormattedMessage
                                        defaultMessage="Voir sur {broadcast}"
                                        description="Button label"
                                        values={{
                                            broadcast: getServiceNameFromUrl(url),
                                        }}
                                    />
                                )}
                            </span>
                        </PillButton>
                    );
                })}
            {(broadcasts || [])
                .filter(
                    ({ type, organisation = null }) =>
                        type !== 'streaming' && organisation !== null,
                )
                .map(({ id, organisation, startAt = null }) => (
                    <div key={`broadcast-${id}`} className={styles.item}>
                        <Sponsor
                            organisation={organisation}
                            withoutPresentedBy
                            withImage
                            className={classNames([styles.sponsor, sponsorClassName])}
                            imageClassName={styles.image}
                        />
                        {startAt !== null ? (
                            <Date date={startAt} withoutDay className={styles.date} />
                        ) : null}
                    </div>
                ))}
        </div>
    );
}

export default Broadcasts;
